import {Vue3Lottie} from 'vue3-lottie';

export default defineNuxtPlugin(({vueApp}) => {
  vueApp.component('VueLottie', Vue3Lottie);
});